import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

import DialogActions from "@material-ui/core/DialogActions";

const useStyles = makeStyles((theme) => ({
  rootRtl: {
    justifyContent: "flex-start",
  },
}));

const IntlDialogActions = (props) => {
  const classes = useStyles();
  const { i18n } = useTranslation();
  return (
    <DialogActions
      classes={{
        root: clsx({ [classes.rootRtl]: i18n.dir() === "rtl" }),
      }}
    >
      {props.children}
    </DialogActions>
  );
};

export default IntlDialogActions;
